import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AllIcons } from 'shared/ui/app-icon/types'
import { ButtonIconText } from 'shared/ui/button-icon-text'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  value?: string
  onClick?: () => void
}

export const GuideDate: FC<Props> = ({ value, onClick }) => {
  const { t } = useTranslation()

  return (
    <Paper padding={[20]}>
      <div className={s.container}>
        <p className={clsx(s.title, 'bold-16')}>
          {t('excursions.change_date')}
        </p>

        <ButtonIconText
          type={'grey'}
          value={value}
          onClick={onClick}
          placeholder={t('when')}
          rightIcon={AllIcons.CALENDAR}
        />
      </div>
    </Paper>
  )
}
